export const BASE_PATH = "https://semenarna-api.kaproscm.com/api";
//export const BASE_PATH = "http://127.0.0.1:8000/api";